import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CardData } from '../PricesSection/PricesSection';
import imgHero from './imgHero.webp';
import styles from './HeroSection.module.scss';

interface HeroSectionProps {
  onOpenPopup: () => void;
  cards: CardData[];
  loading: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onOpenPopup, cards, loading }) => {
  const { t, i18n } = useTranslation();
  const isRu = i18n.language.startsWith('ru');

  return (
    <section className={styles.heroSection}>
      <div className={styles.leftContent}>
        {/* Флаги и названия стран */}
        <div className={styles.country}>
          {loading ? (
            <span style={{ opacity: 0.6, color: 'red' }}>Loading countries...</span>
          ) : cards.length > 0 ? (
            cards.map((country) => (
              <span key={country.id} className={styles.countryItem}>
                <img
                  src={country.flag_url}
                  alt={isRu ? country.name_ru : country.name_en}
                  loading="eager"
                  width="20"
                  height="15"
                  style={{
                    border: '1px solid #000',
                    borderRadius: '50%',
                    width: '20px'
                  }}
                />
                <span>{isRu ? country.name_ru : country.name_en}</span>
              </span>
            ))
          ) : (
            <span style={{ color: 'orange' }}>No countries loaded</span>
          )}
        </div>

        <h1>
          {t('hero.titlePart1')}
          <span className={styles.google}>{t('hero.titleHighlight')}</span>
        </h1>

        <p className={styles.description}>
          {t('hero.description')}
        </p>

        <button className={`${styles.buyButton} ${styles.jump}`} onClick={onOpenPopup}>
          {t('hero.button')}
        </button>
      </div>

      <div className={styles.rightContent}>
        <img
          src={imgHero}
          alt={t('hero.phoneAlt')}
          className={styles.phoneImage}
          fetchPriority="high"
          decoding="async"
          width="1024"
          height="1024"
        />
      </div>
    </section>
  );
};

export default HeroSection;
